module.exports = __webpack_public_path__ + "img/update_apps.8c703391.png";